import React from "react";
import { useRouter } from "next/router";
import Layout from "components/Layout";
import { BackHeader, AccountShell } from "@xt/Nav";
import { Hooks, Platform, Util } from "@xt/xtbase";
import SpikexCard from "@/components/Pages/SpikexCard";
import useIsDesktop from "@/hooks/useIsDesktop";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { buildPageStaticProps } from "@/utils/pageTdkStaticProps";

const { useTranslation } = Hooks;

export default function SpikexCardPage() {
  const router = useRouter();
  const t = useTranslation();
  const isInApp = Platform.isInApp();
  const { isDesktop, isReady } = useIsDesktop();
  const isSpikexPc = isReady && isDesktop;
  const pageTitle = t("spikexCard.title") || "Spikex Card";

  useDocumentTitle(pageTitle);

  const handleBack = () => {
    router.back();
  };

  const headerPad = Platform.isInApp()
    ? "env(safe-area-inset-top, 0px)"
    : "calc(44px + env(safe-area-inset-top, 0px))";

  if (!isInApp && !isReady) {
    return (
      <Layout isShowNav={false} isShowFoot={false} useBottomBar={false}>
        <div />
      </Layout>
    );
  }

  if (!isInApp && isSpikexPc) {
    return (
      <Layout isShowNav isShowFoot={false} useBottomBar={false} accountDesktopSplit>
        <AccountShell tabKey="spikex-card">
          <SpikexCard />
        </AccountShell>
      </Layout>
    );
  }

  return (
    <Layout isShowNav={false} isShowFoot={false} useBottomBar={false}>
      {!isInApp ? <BackHeader title={pageTitle} onBack={handleBack} /> : null}
      <div style={{ paddingTop: headerPad }}>
        <SpikexCard />
      </div>
    </Layout>
  );
}

export async function getStaticProps(context) {
  return buildPageStaticProps(context, "/spikex-card");
}
